export default "__VITE_ASSET__D97uz$bS__"